import React from "react";
import { FiMonitor } from "react-icons/fi";
import { FaRegFileCode } from "react-icons/fa";
import { RiCustomerService2Line } from "react-icons/ri";
import { FaChalkboardTeacher } from "react-icons/fa";
import './Banner.css'
const Services = () => {
    return (
        <div className="md:mt-20 mt-20 w-full lg:px-7" >
            <div data-aos="fade-up"
                data-aos-anchor-placement="center-bottom">
                {/* <h3 className="text- text-4xl text-highlight">
                    {"<"} Services {"/>"}
                </h3> */}
            <h3 className="text- flex justify-center text-4xl mb-6 text-highlight">
                <div className='flex gap-3 items-center justify-center  border-[2px] w-[206px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Services<span className="hover:rotate-180 "> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

            
                </h3>

                <h1 className="md:text-5xl mt-10 text-4xl font-bold md:w-2/3 w-full p-0 mx-auto text-white  text uppercase" >
                    What I Do for My Clients
                </h1>
            </div>

            <div className="grid grid-cols-1 mx-6 md:grid-cols-3 gap-6 mt-10" >
                <div className="shadow-lg bg-[#07072b] hover:bg-[#141516] text-center p-10 rounded-lg flex flex-col row-span-2 justify-center items-center py-10" data-aos="flip-down">
                    <div className="w-16 h-16 rounded-full bg-[#432D92]  p-3 mt-5">
                        <FaRegFileCode
                            style={{
                                position: "relative",
                                width: "60px",
                                height: "60px",
                                top: "-40",
                                right: "50",
                                color: "#00C0FF",
                            }}
                        />
                    </div>
                    <div className="mt-5 ">
                        <h3 className="text-3xl font-bold text-white border-white px-3 rounded-3xl">
                            {" Full-Stack Web Development"}
                        </h3>
                        <p className="mt-5 leading-9">
                        As a leading full-stack development company, Brainier has expertise in all technologies, from front-end to back-end. Our full-stack development services
                        </p>
                    </div>
                </div>
                <div className="shadow-lg bg-[#07072b] hover:bg-[#141516] text-center p-10 rounded-lg  flex flex-col justify-center items-center py-10 " data-aos="zoom-in-down">
                    <div className="w-16 h-16 rounded-full bg-[#432D92] p-3 mt-5">
                        <RiCustomerService2Line
                            style={{
                                position: "relative",
                                width: "50px",
                                height: "50px",
                                top: "-30",
                                right: "30",
                                color: "#00C0FF",
                            }}
                        />
                    </div>
                    <div className="mt-5" >
                        <h3 className="text-3xl font-bold text-white border-white px-3 rounded-3xl">
                            {"Programming Support"}
                        </h3>
                        <p className="mt-5 leading-9 md:leading-normal">
                        We develop, debug, and optimize code to effectively use resources improve code performance, and help you collaborate with users
                        </p>
                    </div>
                </div>
                <div className="shadow-lg bg-[#07072b] hover:bg-[#141516] text-center p-10 rounded-lg row-span-2 flex flex-col justify-center items-center py-10" data-aos="flip-down">
                    <div className="w-16 h-16 rounded-full bg-[#432D92] p-3 mt-5">
                        <FiMonitor
                            style={{
                                position: "relative",
                                width: "60px",
                                height: "60px",
                                top: "-40",
                                right: "50",
                                color: "#00C0FF",
                            }}
                        />
                    </div>
                    <div className="mt-5" >
                        <h3 className="text-3xl font-bold text-white border-white px-3 rounded-3xl">
                            {"Web Design"}
                        </h3>
                        <p className="mt-5 leading-9">
                            the process of planning, conceptualizing, and implementing the plan for designing a website in a way that is functional and offers a good user experience.
                        </p>
                    </div>
                </div>
                <div className="shadow-lg bg-[#07072b] hover:bg-[#141516] text-center p-10 rounded-lg  flex flex-col justify-center items-center py-10 " data-aos="fade-up"
                    data-aos-duration="2500">
                    <div className="w-16 h-16 rounded-full bg-[#432D92] p-3 mt-5">
                        <FaChalkboardTeacher
                            style={{
                                position: "relative",
                                width: "60px",
                                height: "60px",
                                top: "-30",
                                right: "30",
                                color: "#00C0FF",
                            }}
                        />
                    </div>
                    <div className="mt-5">
                        <h3 className="text-3xl font-bold text-white border-white px-3 rounded-3xl">
                            {"Teaching Web Development"}
                        </h3>
                        <p className="mt-5 leading-9 md:leading-normal">
                            Focus on the basics of HTML, CSS, and JavaScript, or explore more advanced topics such as frameworks, libraries, APIs, or databases.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
